import { useTranslation } from '@/context/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { useState } from 'react';
import { Send, Mail, MapPin } from 'lucide-react';
import { toast } from 'sonner';

export default function Contact() {
  const { t } = useTranslation();
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    toast.success(t('contact.sent'));
  };

  return (
    <div className="py-16 md:py-24" data-testid="contact-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl text-[#1E293B] mb-4" >
            {t('contact.title')}
          </h1>
          <p className="text-base md:text-lg text-[#64748B]">{t('contact.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          <Card className="border border-[#E2E8F0]/40 rounded-2xl shadow-sm">
            <CardContent className="p-8">
              {sent ? (
                <div className="text-center py-12">
                  <div className="w-16 h-16 rounded-full bg-[#00CC99]/10 flex items-center justify-center mx-auto mb-4">
                    <Send className="w-8 h-8 text-[#00CC99]" />
                  </div>
                  <h3 className="text-xl font-medium text-[#1E293B] mb-2" >{t('contact.sent')}</h3>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div>
                    <Label htmlFor="name" className="text-sm text-[#64748B]">{t('contact.name')}</Label>
                    <Input id="name" required className="mt-1 h-12 rounded-lg border-[#E2E8F0] focus:ring-[#3A86FF]/20 focus:border-[#3A86FF]" data-testid="contact-name" />
                  </div>
                  <div>
                    <Label htmlFor="email" className="text-sm text-[#64748B]">{t('contact.email')}</Label>
                    <Input id="email" type="email" required className="mt-1 h-12 rounded-lg border-[#E2E8F0] focus:ring-[#3A86FF]/20 focus:border-[#3A86FF]" data-testid="contact-email" />
                  </div>
                  <div>
                    <Label htmlFor="message" className="text-sm text-[#64748B]">{t('contact.message')}</Label>
                    <Textarea id="message" required rows={5} className="mt-1 rounded-lg border-[#E2E8F0] focus:ring-[#3A86FF]/20 focus:border-[#3A86FF]" data-testid="contact-message" />
                  </div>
                  <Button type="submit" className="w-full rounded-full bg-[#3A86FF] hover:bg-[#3A86FF]/90 text-white py-5" data-testid="contact-send-btn">
                    {t('contact.send')}
                    <Send className="w-4 h-4 ml-2" />
                  </Button>
                </form>
              )}
            </CardContent>
          </Card>

          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#3A86FF]/10 flex items-center justify-center flex-shrink-0">
                <Mail className="w-5 h-5 text-[#3A86FF]" strokeWidth={1.5} />
              </div>
              <div>
                <h3 className="font-medium text-[#1E293B] mb-1">Email</h3>
                <p className="text-sm text-[#64748B]">hello@lifepulse.io</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#3A86FF]/10 flex items-center justify-center flex-shrink-0">
                <MapPin className="w-5 h-5 text-[#3A86FF]" strokeWidth={1.5} />
              </div>
              <div>
                <h3 className="font-medium text-[#1E293B] mb-1">Location</h3>
                <p className="text-sm text-[#64748B]">Europe (EU)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
